import { SectorDataState } from '../types';

export const SCOPING_SECTORS: SectorDataState = {
  Alpha: [],
  Beta: [],
  Gamma: [],
  Delta: [],
};
